module.exports = __webpack_public_path__ + "static/media/Icon1docwallet.14f06d89.png";